import { useEffect } from 'react';

const useAdaptiveViewport = () => {
  useEffect(() => {
    const viewportMetaElement = document.createElement('meta');
    viewportMetaElement.name = 'viewport';
    viewportMetaElement.content = 'width=device-width, initial-scale=1.0';

    const originalViewport = document.querySelector('meta[name="viewport"]');

    if (originalViewport) {
      originalViewport.remove();
    }

    document.head.appendChild(viewportMetaElement);

    return () => {
      viewportMetaElement.remove();
      document.head.appendChild(originalViewport);
    };
  }, []);
};

export default useAdaptiveViewport;
